import { render, staticRenderFns } from "./#zhiwei.vue?vue&type=template&id=57a31eae&"
import script from "./#zhiwei.vue?vue&type=script&lang=js&"
export * from "./#zhiwei.vue?vue&type=script&lang=js&"
import style0 from "./#zhiwei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports